import { render, staticRenderFns } from "./DialogUserSettings.vue?vue&type=template&id=4db20368&"
import script from "./DialogUserSettings.vue?vue&type=script&lang=js&"
export * from "./DialogUserSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4db20368')) {
      api.createRecord('4db20368', component.options)
    } else {
      api.reload('4db20368', component.options)
    }
    module.hot.accept("./DialogUserSettings.vue?vue&type=template&id=4db20368&", function () {
      api.rerender('4db20368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/global/DialogUserSettings.vue"
export default component.exports